type FileType = "image" | "video" | "audio" | "pdf" | "unknown"

export function getFileType(filename: string): FileType {
  const ext = filename.split(".").pop()?.toLowerCase() || ""
  if (["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(ext)) return "image"
  if (["mp4", "webm", "ogg"].includes(ext)) return "video"
  if (["mp3", "wav"].includes(ext)) return "audio"
  if (["pdf"].includes(ext)) return "pdf"
  return "unknown"
}
